/* src/app/forms/formview/copy-form-configuration/copy-form-configuration.component.scss */
:host {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  height: 100%;
  max-height: 50vh;
  min-height: 50vh;
  overflow: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 4px;
}
.content-data {
  max-height: 110px;
  min-height: 110px;
}
.opcao {
  display: flex;
  flex-direction: row;
  width: 100%;
  font-weight: bold;
  border: 1px solid var(--tem-border);
  padding-left: 20px;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-right: 20px;
  font-size: 80%;
  border-radius: var(--tem-radius);
}
.switch-label {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
  cursor: pointer;
}
.flex-spacer {
  flex-grow: 1;
}
.select-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  box-shadow: var(--tem-shadow);
  background: var(--tem-surface);
}
.user-option {
  padding: 6px 12px;
  margin: 0;
  border-bottom: 1px solid var(--tem-border);
}
.user-option:hover {
  background: var(--tem-accent-soft);
}
.user-option:last-child {
  border-bottom: none;
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.label-users {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.separatorCenter {
  text-align: center;
}
.lblUsuDest {
  margin-left: 12px;
}
.fontDivisor {
  font-weight: bold;
}
.finish {
  margin-top: 10px;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
}
button {
  width: 100%;
}
.responsive {
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=copy-form-configuration.component.css.map */
